import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { Capacitor } from '@capacitor/core'
import './style.css'
import App from './App.vue'
import router from './router'
import i18n from './i18n'

// Add platform class to <html> for platform-specific CSS
const platform = Capacitor.getPlatform() // 'android' | 'ios' | 'web'
document.documentElement.classList.add(`platform-${platform}`)

const app = createApp(App)
const pinia = createPinia()

// Register plugins
app.use(pinia)
app.use(router)
app.use(i18n)

// Register Firebase service worker (web only)
if (!Capacitor.isNativePlatform() && 'serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Firebase SW registered:', registration.scope)
    })
    .catch((err) => {
      console.warn('Firebase SW registration failed:', err)
    })

  // Listen for notification click messages from service worker
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'NOTIFICATION_CLICK' && event.data.url) {
      router.push(event.data.url)
    }
  })
}

// Native platform setup (Android back button + deep links)
if (Capacitor.isNativePlatform()) {
  import('@capacitor/app').then(({ App: CapApp }) => {
    // Android hardware back button
    CapApp.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        router.back()
      } else {
        CapApp.exitApp()
      }
    })

    // Deep links
    CapApp.addListener('appUrlOpen', (event) => {
      const url = new URL(event.url)
      const path = url.pathname
      if (path) {
        router.push(path)
      }
    })
  })
}

// Mount app
app.mount('#app')
